export default __webpack_public_path__ + "static/media/obj.1754f57e.svg";